import endpoint from 'utils/endpoint';
import { HttpRequestMethodTypes } from 'types';
import { getGoSearchHost, isServerSide } from 'utils/host-config';
import type { SearchPredictionsApiResponse, SearchPredictionsParams } from './types';


// TODO: This is a temporary function to fetch search predictions from the go-search service in JSON format.
// Next step is to use proto models for the request and response.
export async function fetchSearchPredictions(
  params: SearchPredictionsParams,
  host: string = getGoSearchHost(isServerSide())
): Promise<SearchPredictionsApiResponse | null> {
  try {
    const searchPredictionsUrl = '/api/search-predictions';

    const response = await endpoint<SearchPredictionsApiResponse>(
      searchPredictionsUrl,
      HttpRequestMethodTypes.GET,
      params,
      {}, // headers
      undefined, // body
      host
    );

    return response;
  } catch (error) {
    console.error('Error fetching search predictions:', error);
    return null;
  }
}
